var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder music") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "#de6139",
    stroke: "#de6139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,22H3a2,2,0,0,1-2-2V2H9l3,4H23V20a2,2,0,0,1-2,2H20",
    fill: "none",
    stroke: "#de6139",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    "data-color": "color-2",
    points: "17 18.5 17 11 10 11 10 20.5",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    "data-stroke": "none",
    cx: 8.5,
    cy: 20.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    "data-stroke": "none",
    cx: 15.5,
    cy: 18.5,
    r: 2.5,
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMusic);
export default __webpack_public_path__ + "static/media/folder-music.a0a53310.svg";
export { ForwardRef as ReactComponent };